import type { Tenant } from './database.types';

/**
 * Atouts de réassurance (bande « 3 atouts ») — logique pure (parité C3).
 * Séparée du composant TrustBand pour rester testable et éviter les soucis
 * de fast-refresh (un fichier de composant ne doit exporter que des composants).
 */
export interface TrustItem {
  icon: string;
  title: string;
  subtitle: string;
}

/** Atouts par défaut (legacy) — le 1er intègre le délai de préparation du tenant. */
export function defaultTrustItems(prepMin: number): TrustItem[] {
  return [
    { icon: '⏱️', title: `Prêt en ${prepMin} minutes`, subtitle: 'Préparé minute après votre commande' },
    { icon: '🥬', title: 'Produits frais', subtitle: 'Recettes maison, ingrédients frais' },
    { icon: '💳', title: 'Paiement libre', subtitle: 'En ligne ou sur place, comme vous voulez' },
  ];
}

/** Résout les atouts à afficher : ceux du tenant (si fournis et non vides), sinon les défauts. */
export function resolveTrustItems(tenant: Tenant): TrustItem[] {
  const prepMin = tenant.prep_time_min ?? 15;
  const custom = tenant.trust_items;
  if (Array.isArray(custom) && custom.length > 0) {
    return custom
      .filter((it) => it && (it.title || it.subtitle))
      .map((it) => ({ icon: it.icon || '•', title: it.title ?? '', subtitle: it.subtitle ?? '' }));
  }
  return defaultTrustItems(prepMin);
}
